module.exports = __webpack_public_path__ + "static/smell-69b2786f706f3d20620100083b964921.jpg";